import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useDevice } from '@/contexts/DeviceContext';
import { Header } from '@/components/Header';
import { ReservationModal } from '@/components/ReservationModal';
import MenuBookIcon from '@/assets/icons/menu-book-white.svg?react';
import ShuttleIcon from '@/assets/icons/airport-shuttle-white.svg?react';
import NoteIcon from '@/assets/icons/event-note-white.svg?react';
import RestaurantIcon from '@/assets/icons/restaurant-white.svg?react';
import './Selection.scss';

// 더미 사용자 정보 제거 (Header로 이동)

export function Selection() {
    const navigate = useNavigate();
    const { isMobile } = useDevice();
    const { user } = useAuth();
    const [isReservationModalOpen, setIsReservationModalOpen] = useState(false);

    // 서비스 선택
    const handleServiceSelect = (service: string) => {
        if (service === 'study-cafe') {
            navigate('/study-cafe');
        } else if (service === 'bus') {
            navigate('/bus');
        } else if (service === 'dinner') {
            navigate('/dinner');
        } else if (service === 'history') {
            setIsReservationModalOpen(true);
        }
    };

    return (
        <div className={`selection-page ${isMobile ? 'selection-page--mobile' : ''}`}>
            {/* 공통 헤더 */}
            <Header />

            {/* 메인 영역 */}
            <main className="selection-main">
                {/* 환영 메시지 */}
                <h1 className="welcome-message">
                    <span className="user-name">{user?.name}</span> 님, 원하시는 서비스를 선택해주세요.
                </h1>

                {/* 서비스 카드들 */}
                <div className="service-cards">
                    {/* 스터디카페 좌석 예약 */}
                    <button
                        className="service-card service-card--study"
                        onClick={() => handleServiceSelect('study-cafe')}
                    >
                        <div className="service-card__icon service-card__icon--blue">
                            <MenuBookIcon className="icon-svg" />
                        </div>
                        <div className="service-card__text">
                            <span>스터디카페</span>
                            <span>좌석 예약</span>
                        </div>
                    </button>

                    {/* 별빛버스 승차 예약 */}
                    <button
                        className="service-card service-card--bus"
                        onClick={() => handleServiceSelect('bus')}
                    >
                        <div className="service-card__icon service-card__icon--mint">
                            <ShuttleIcon className="icon-svg" />
                        </div>
                        <div className="service-card__text">
                            <span>별빛버스</span>
                            <span>승차 예약</span>
                        </div>
                    </button>

                    <button
                        className="service-card service-card--dinner"
                        onClick={() => handleServiceSelect('dinner')}
                    >
                        <div className="service-card__icon service-card__icon--navy">
                            <RestaurantIcon className="icon-svg" />
                        </div>
                        <div className="service-card__text">
                            <span>석식 신청</span>
                        </div>
                    </button>

                    {/* 예약 내역 확인 */}
                    <button
                        className="service-card service-card--history"
                        onClick={() => handleServiceSelect('history')}
                    >
                        <div className="service-card__icon service-card__icon--gray">
                            <NoteIcon className="icon-svg" />
                        </div>
                        <div className="service-card__text">
                            <span>예약 내역 확인</span>
                            <span className="sub-text">(스터디카페 입장)</span>
                        </div>
                    </button>
                </div>
            </main>

            {/* 예약 내역 팝업 */}
            <ReservationModal
                isOpen={isReservationModalOpen}
                onClose={() => setIsReservationModalOpen(false)}
            />
        </div>
    );
}
